import React, { useState } from "react";
import * as Yup from "yup";
import {
  Form as BaseForm,
  TextField,
  SubmitButton,
  CancelPopupButton,
} from "../../../../ui/FormElement";
import { useCoachPoolContext } from "../../../../contexts/CoachPoolContext";

export default function Form() {
  let FormSchema = Yup.object().shape({
    name: Yup.string().required("Coach Pool Name is required"),
  });

  let [loader, setLoader] = useState(false);

  const { dispatch, state, actions } = useCoachPoolContext();

  const [formData, setFormData] = useState({
    name: "",
  });

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    actions.createCoachPool(
      dispatch,
      values,
      () => {
        setLoader(false);
        actions.hideModal(dispatch);
        actions.loadCoachPools(dispatch);
      },
      (errorData) => {
        let newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace("/data/attributes/", "")] =
            item.detail;
        });
        setErrors(newErrors);
        setLoader(false);
      }
    );
  };

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <TextField
        name="name"
        label={
          <>
            <span>Coach Pool Name</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={() => actions.hideModal(dispatch)}
        />
        <SubmitButton
          title={loader ? "Please, wait ..." : "Create"}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? "not-possible-click" : ""
          }`}
        />
      </div>
    </BaseForm>
  );
}
